import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '@ds';
import { SSchedulerSettingsRulesFormType } from '@lp/features/Scheduler/SchedulerSurgeonsSettings/types';
import { getNumberInputValue, getNumberInputValueHandler } from '@lp/features/Scheduler/utils';

export const SSchedulerSettingsRulesForm = () => {
  const { control } = useFormContext<SSchedulerSettingsRulesFormType>();

  return (
    <div>
      <p className="mb-4 text-xl-sb text-base-5">Individual Workload Guardrails</p>
      <div className="flex flex-col gap-6 w-3/5 p-6 bg-white rounded-2xl shadow-s">
        <div className="flex flex-col gap-3">
          <span className="text-l-m">No-Call Days per Month</span>
          <div className="flex gap-2">
            <Controller
              name="minNoCallDaysPerPeriod"
              control={control}
              render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => (
                <Input
                  type="number"
                  label="Min"
                  min={0}
                  isInvalid={invalid}
                  errorMessage={error?.message}
                  className="w-[160px]"
                  value={getNumberInputValue(value)}
                  onValueChange={getNumberInputValueHandler(onChange)}
                  {...field}
                />
              )}
            />
            <Controller
              name="maxNoCallDaysPerPeriod"
              control={control}
              render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => (
                <Input
                  type="number"
                  label="Max"
                  min={0}
                  isInvalid={invalid}
                  errorMessage={error?.message}
                  className="w-[160px]"
                  value={getNumberInputValue(value)}
                  onValueChange={getNumberInputValueHandler(onChange)}
                  {...field}
                />
              )}
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 pb-4">
          <span className="text-l-m">No-Call Days in-row</span>
          <div className="flex gap-2 w-[160px]">
            <Controller
              name="noCallInRow.hardMax"
              control={control}
              render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => (
                <Input
                  type="number"
                  min={0}
                  isInvalid={invalid}
                  errorMessage={error?.message}
                  value={getNumberInputValue(value)}
                  onValueChange={getNumberInputValueHandler(onChange)}
                  {...field}
                />
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
